/* eslint-disable */
import { ref, watch, computed } from "@vue/composition-api";
import { title } from "@core/utils/filter";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import { GetPagingParams } from "@/services/api/DefaultTemplate/UserService";
import { GetUserInfo } from "@/services/api/DefaultTemplate/AuthService";
import { GetTree } from "@/services/api/DefaultTemplate/DonViService";
export default function useUsersList(props, emit) {
  const toast = useToast();

  const refUserListTable = ref(null);

  const tableColumns = [
    {
      key: "index",
      label: "STT",
      sortable: true,
      thStyle: "text-align: center; width: 50px;",
    },
    { key: "user", label: "Người dùng" },
    {
      key: "donVi",
      label: "Đơn vị",
      // sortable: true
    },
    {
      key: "unitRoleCode",
      label: "Vai trò",
      class: "text-center",
      // sortable: true,
    },
    {
      key: "isActived",
      label: "Trạng thái",
      class: "text-center",
      // sortable: true,
    },

    {
      key: "actions",
      label: "#",
      thStyle: "text-align: center; width: 50px;",
    },
  ];

  const perPage = ref(10);
  const totalUsers = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];

  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);
  const donViId = ref(null);
  const status = ref(true);
  const donVis = ref([]);

  const loginUser = GetUserInfo();

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value
      ? refUserListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    };
  });

  const refetchData = () => {
    refUserListTable.value.refresh();
  };
  const getDonVi = () => {
    GetTree().then((response) => {
      // console.log("response", response);
      donVis.value = response.data;
    });
  };
  getDonVi();

  const fetchUsers = (ctx, callback) => {
    let condition = {
      donViId: donViId.value,
      start: currentPage.value,
      limit: perPage.value,
      content: searchQuery.value,
      status: status.value,
      // sortBy: loadFilter.value,
    };
    GetPagingParams(condition).then((response) => {
      // console.log("response", response);
      if (!response.isError) {
        const { data, totalRows } = response.data;

        //Auto remove me login
        let index = data.findIndex((x) => x.userName == loginUser.username);
        if (index != -1) {
          data.splice(index, 1);
        }

        callback(data);
        totalUsers.value = totalRows;
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: "Thất bại",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: response.message,
          },
        });
      }
    });
  };

  const resolveUserLockedVariant = (status) => {
    if (status == false) return "secondary";
    return "success";
  };

  watch([currentPage, perPage, searchQuery, donViId, status], () => {
    refetchData();
  });

  return {
    fetchUsers,
    getDonVi,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,
    donViId,
    status,
    donVis,

    resolveUserLockedVariant,
    refetchData,

    // lockFilter,
  };
}
